import { HackleUser } from "../../../model/model"
import { PropertyOperations } from "../../../../../hackle/property/PropertyOperations"
import { WorkspaceEvaluationContext, WorkspaceEvaluationContextKey } from "../WorkspaceEvaluationContext"
import { RemoteEvaluateContextDto } from "./dto"

/**
 * The input to a remote evaluation request: the user and any pending property operations.
 * `key` derives the cache key from the user.
 */
export class RemoteEvaluateContext {
  private constructor(readonly user: HackleUser, readonly operations: PropertyOperations) {}

  get key(): WorkspaceEvaluationContextKey {
    return WorkspaceEvaluationContext.keyOf(this.user)
  }

  toDto(): RemoteEvaluateContextDto {
    return {
      user: {
        identifiers: this.user.identifiers,
        userProperties: this.user.properties,
        hackleProperties: this.user.hackleProperties
      },
      operations: this.operations.toRecord()
    }
  }

  static of(user: HackleUser, operations: PropertyOperations = new PropertyOperations()): RemoteEvaluateContext {
    return new RemoteEvaluateContext(user, operations)
  }
}
